import React from 'react';
import InternalContainer from '../../layout/containers/Internal';
import ContentAnnouncementList from '../components/ContentAnnouncementList';

// import { getKeyPersonnel, getPartners } from '../redux/contentActions'

const AnnouncementList = () => {
  return (
    <InternalContainer title="Announcement List">
      <ContentAnnouncementList />
    </InternalContainer>
  );
};

export default AnnouncementList;
